import { SHIPMENT_STATUS, SHIPMENT_STATUS_LABELS } from "../utils/enums";
import SortDropdown from "./SortDropdown";

const ORDER = [
  SHIPMENT_STATUS.ALL,
  SHIPMENT_STATUS.PENDING,
  SHIPMENT_STATUS.CONFIRMED,
  SHIPMENT_STATUS.COLLECTED,
  SHIPMENT_STATUS.IN_TRANSIT,
  SHIPMENT_STATUS.COMPLETED,
  SHIPMENT_STATUS.CANCELLED,
];

const OPTIONS = ORDER.map((v) => ({ value: v, label: SHIPMENT_STATUS_LABELS[v] }));

const ShipmentStatusDropdown = ({ value, onChange }: any) => (
  <SortDropdown
    label="Shipment"
    icon="bi-funnel"
    options={OPTIONS}
    value={value || SHIPMENT_STATUS.ALL}
    onChange={onChange}
  />
);

export default ShipmentStatusDropdown;
